module.exports = __webpack_public_path__ + "img/icon_map_4_yj.5751509c.png";